import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, RedirectFunction, Router } from '@angular/router'

import { ORGANIZATION_ADMIN_WORKSPACE_ID } from '@flowx/designer/modules/workspaces/shared/commons.types'

import { WorkspacesAndPermissionsStore } from './modules/workspaces/workspaces-and-permissions.store'

export function calculateAppDefaultRoute(): RedirectFunction {
  return (routeSnapshot: ActivatedRouteSnapshot) => {
    const router = inject(Router)
    const userIsOrganizationSaasAdmin = inject(
      WorkspacesAndPermissionsStore
    ).userIsOrganizationSaasAdmin()
    if (userIsOrganizationSaasAdmin) {
      return router.createUrlTree(['guard', 'organisation-admin', 'projects'])
    }

    const storedWorkspaceId = localStorage.getItem('FlxWorkspaceId')
    if (storedWorkspaceId) {
      if (storedWorkspaceId === ORGANIZATION_ADMIN_WORKSPACE_ID) {
        return router.createUrlTree(['guard', 'organisation-admin'])
      }
      return router.createUrlTree(['guard', 'workspace', storedWorkspaceId, 'projects'])
    }

    return router.createUrlTree(['guard', 'workspaces-select'], {
      queryParams: { ...routeSnapshot.queryParams, canSkipLocation: true },
      queryParamsHandling: 'merge',
    })
  }
}

export const commandCenterKey = 'commandCenter'
